import { App, DirectiveBinding } from 'vue';

/**
 * The click-outside directive is used to detect when a click
 * was outside of the element where this directive was used.
 * Usage as below:
 *
 * v-click-outside="onClickOutside"
 *
 * @type {import("vue").DirectiveOptions}
 */
export const ClickOutsideDirective = {
  beforeMount: (el: any, binding: DirectiveBinding) => {
    el.clickInsideEvent = (event) => {
      event.stopPropagation();
    };
    el.clickOutsideEvent = () => {
      binding.value();
    };

    el.addEventListener('click', el.clickInsideEvent);
    document.addEventListener('click', el.clickOutsideEvent);
  },
  unmounted: (el: any) => {
    el.removeEventListener('click', el.clickInsideEvent);
    document.removeEventListener('click', el.clickOutsideEvent);
  },
};

export function registerDirective(Vue: App) {
  Vue.directive('click-outside', ClickOutsideDirective);
}
